import { render } from "./Chrome.vue?vue&type=template&id=1b2d6dfc&scoped=true"
import script from "./Chrome.vue?vue&type=script&lang=js"
export * from "./Chrome.vue?vue&type=script&lang=js"

import "./Chrome.vue?vue&type=style&index=0&id=1b2d6dfc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b2d6dfc"

export default script